module.exports = __webpack_public_path__ + "img/sky_world.51bf9e6a.svg";